import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconHomeSolid24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="home solid">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.8906 7.40638C1.3342 7.77731 1 8.40177 1 9.07048V24.0001H8V16.0001C8 14.8955 8.89543 14.0001 10 14.0001H14C15.1046 14.0001 16 14.8955 16 16.0001V24.0001H23V9.07048C23 8.40177 22.6658 7.77731 22.1094 7.40638L13.1094 0.739708C12.4376 0.291842 11.5624 0.291842 10.8906 0.739708L1.8906 7.40638Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
